import * as React from "react";
import { Show, SimpleShowLayout, TextField } from 'react-admin';
const CodeDetail = ({...props }) => (

    <Show title="Code Detail" {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
           
            <TextField source="code" label="Code" />
            <TextField source="type" label="Type" />
            <TextField source="start_code" label="Start Code" />
            <TextField source="end_code" label="End Code" />
            <TextField source="status" label="Status" />
        </SimpleShowLayout>
    </Show>
     );
export default CodeDetail